import React, { useState, useEffect } from "react";
import { Box, Flex, Heading, Text, useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import useThemeColors from "../../../../../hooks/useThemeColors";
import { textSecondary } from "../../../../../utils/colors";
import SaveButtons from "./SaveButtons";
import { useDispatch, useSelector } from "react-redux";
import { TENANT_UPDATE_DEFAULT_COORDINATOR_RESET } from "../../../../../constants/tenantConstants";
import { updateTenantDefaultCoordinatorAction } from "../../../../../actions/tenantActions";
import FormControlEmployee from "../../../../../components/input/FormControlEmployee";

const ClinicDefaultEmployeeTreatmentPlans = ({ slug, tenant }) => {
  // GENERAL
  // const { slug } = useParams();
  const { t } = useTranslation();
  const toast = useToast();

  // COLORS
  const { backgroundLightMode, newBorderMode } = useThemeColors();

  // STATE
  const [showButtons, setShowButtons] = useState(false);

  const [operatingCountry, setOperatingCountry] = useState(
    tenant?.operatingCountry || ""
  );

  const [employee, setEmployee] = useState(
    tenant?.defaultTreatmentPlanEmployee
  );

  // REDUX
  const dispatch = useDispatch();

  const tenantUpdateDefaultCoordinator = useSelector(
    (state) => state.tenantUpdateDefaultCoordinator
  );
  const { loading, success, error, defaultTreatmentPlanEmployee } =
    tenantUpdateDefaultCoordinator;

  // HANDLERS
  const updateCoordinatorHandler = () => {
    dispatch(updateTenantDefaultCoordinatorAction(slug, employee?.value));
  };

  // USE EFFECT

  // const normalizeValue = (value) =>
  //   value === undefined || value === null ? "" : String(value).trim();

  // useEffect(() => {
  //   // console.log("Checking for changes...");

  //   if (
  //     normalizeValue(operatingCountry) !==
  //     normalizeValue(tenant?.operatingCountry)
  //   ) {
  //     // console.log("Setting showButtons to TRUE");
  //     setShowButtons(true);
  //   } else {
  //     // console.log("Setting showButtons to FALSE");
  //     setShowButtons(false);
  //   }
  // }, [operatingCountry, tenant]);

  useEffect(() => {
    if (tenant && tenant.defaultTreatmentPlanEmployee) {
      const fullEmployee = tenant.defaultTreatmentPlanEmployee;
      setEmployee({
        value: fullEmployee._id,
        label: `${fullEmployee.firstName || ""} ${
          fullEmployee.lastName || ""
        }`.trim(),
      });
    }
  }, [tenant]);

  useEffect(() => {
    if (success) {
      toast({
        title: t("toasts.clinicUpdateDefaultCoordinatorSuccess"),
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setShowButtons(false);
    } else if (error) {
      toast({
        title: t("toasts.clinicUpdateDefaultCoordinatorError"),
        status: "error",
        duration: 3000,

        isClosable: true,
      });
    }

    dispatch({ type: TENANT_UPDATE_DEFAULT_COORDINATOR_RESET });
  }, [success, error]);

  // LOGS
  // console.log("tenant", tenant);
  // console.log("showButtons", showButtons);
  // console.log("clinicName", clinicName);
  // console.log("registrationEmail", registrationEmail);
  // console.log("supportEmail", supportEmail);
  // console.log("phone", phone);
  // console.log("address", address);
  // console.log("operatingCountry", operatingCountry);
  // console.log("defaultTreatmentPlanEmployee", defaultTreatmentPlanEmployee);
  // console.log("employee", employee);

  return (
    <Box
      w="100%"
      p={["1.5rem 0", "3rem 0rem 3rem"]}
      borderBottom={`1px solid ${newBorderMode}`}
    >
      <Flex
        w="100%"
        justify="space-between"
        gap={["1.5rem", "2rem"]}
        direction={["column", "row"]}
      >
        {/* LEFT START */}
        <Flex direction="column" gap={2} w={["100%", "40%"]}>
          <Heading fontSize="1rem" fontWeight="600" p={["0 1.5rem", "initial"]}>
            {t("clinicSettings.clinicDefaultCoordinatorTitle")}
          </Heading>
          <Text
            color={textSecondary}
            fontSize="sm"
            fontWeight="500"
            p={["0 1.5rem", "initial"]}
          >
            {t("clinicSettings.clinicDefaultCoordinatorText")}
          </Text>
        </Flex>
        {/* LEFT END */}

        {/* RIGHT START */}
        <Flex
          w={["100%", "800px"]}
          direction="column"
          justify="flex-start"
          align="flex-start"
        >
          <Flex
            direction="column"
            w="100%"
            bg={backgroundLightMode}
            borderRadius="1rem"
            p="1.25rem 1.5rem 1.25rem"
          >
            <Flex w="100%">
              <FormControlEmployee
                labelFontSize="0.8em"
                label={t("clinicSettings.defaultTreatmentPlanEmployee")}
                placeholder={t("placeholder.creatorEmployee")}
                value={employee?.value || null}
                setValue={setEmployee}
                isRequired
                isDisabled={loading}
                onChange={(selected) => {
                  setEmployee(selected); // full { value, label } object
                  setShowButtons(true);
                }}
              />
            </Flex>
          </Flex>
        </Flex>
        {/* RIGHT END */}
      </Flex>

      {/* BUTTONS */}
      {showButtons && (
        <SaveButtons
          onClose={() => {
            setShowButtons(false);
            setOperatingCountry(tenant?.operatingCountry || "");
          }}
          onClick={updateCoordinatorHandler}
          loading
        />
      )}
    </Box>
  );
};

export default ClinicDefaultEmployeeTreatmentPlans;
